import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';



const ChallengeCreation = () => {
  const [challenges, setChallenges] = useState([
    {
      id: 1,
      name: 'January Fitness Challenge',
      type: 'individual',
      status: 'active',
      participants: 247,
      startDate: '2026-01-01',
      endDate: '2026-01-31'
    },
    {
      id: 2,
      name: 'Team Cardio Blast',
      type: 'team',
      status: 'active',
      participants: 48,
      startDate: '2026-01-15',
      endDate: '2026-01-29'
    }
  ]);

  return (
    <div className="space-y-6">
      <div className="card">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl font-heading font-semibold text-foreground mb-1">
              Challenge Creation & Management
            </h2>
            <p className="text-sm text-muted-foreground">
              Create gym-wide competitions and track participation
            </p>
          </div>
          <Button iconName="Plus">
            Create Challenge
          </Button>
        </div>

        <div className="space-y-3">
          {challenges?.map((challenge) => (
            <div
              key={challenge?.id}
              className="p-4 rounded-lg border border-border hover:border-border/60 transition-colors"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="font-semibold text-foreground">{challenge?.name}</h3>
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        challenge?.type === 'team' ?'bg-accent/20 text-accent' :'bg-primary/20 text-primary'
                      }`}
                    >
                      {challenge?.type === 'team' ? 'Team' : 'Individual'}
                    </span>
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-success/20 text-success">
                      {challenge?.status}
                    </span>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <span>
                      <Icon name="Users" size={14} className="inline mr-1" />
                      {challenge?.participants} participants
                    </span>
                    <span>
                      <Icon name="Calendar" size={14} className="inline mr-1" />
                      {new Date(challenge?.startDate)?.toLocaleDateString()} - {new Date(challenge?.endDate)?.toLocaleDateString()}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Button variant="outline" size="sm" iconName="BarChart3">
                    View Stats
                  </Button>
                  <Button variant="outline" size="sm" iconName="Edit">
                    Edit
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Automated Scoring */}
      <div className="card">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Automated Scoring & Winner Selection
        </h2>
        <p className="text-sm text-muted-foreground mb-4">
          Configure automatic scoring rules and winner determination criteria
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-4 rounded-lg border border-border">
            <div className="flex items-center gap-2 mb-3">
              <Icon name="Target" size={20} color="var(--color-primary)" />
              <h3 className="font-medium text-foreground">Scoring Rules</h3>
            </div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <Icon name="CheckCircle" size={14} className="mt-0.5" />
                <span>Real-time progress tracking</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="CheckCircle" size={14} className="mt-0.5" />
                <span>Automated milestone notifications</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="CheckCircle" size={14} className="mt-0.5" />
                <span>Leaderboard auto-updates</span>
              </li>
            </ul>
          </div>
          <div className="p-4 rounded-lg border border-border">
            <div className="flex items-center gap-2 mb-3">
              <Icon name="Trophy" size={20} color="var(--color-warning)" />
              <h3 className="font-medium text-foreground">Winner Selection</h3>
            </div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <Icon name="CheckCircle" size={14} className="mt-0.5" />
                <span>Automatic winner determination</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="CheckCircle" size={14} className="mt-0.5" />
                <span>Reward distribution automation</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="CheckCircle" size={14} className="mt-0.5" />
                <span>Winner announcement emails</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeCreation;